// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';

export type { Category } from './types.ts';

import { LoadingCategories, LoadingInlineCategories } from './LoadingCategories.tsx';

export const CategorySelector = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CategorySelector" */ './CategorySelector.tsx'))
			.CategorySelector,
	loading: () => <LoadingCategories />,
});

export const InlineCategorySelector = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-InlineCategorySelector" */ './InlineCategorySelector.tsx'
			)
		).InlineCategorySelector,
	loading: () => <LoadingInlineCategories />,
});
